import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { LANGS } from "../../lib/routes";

// Scroll to top on route change, EXCEPT when only the language segment changed.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevRef = useRef(pathname);

  useEffect(() => {
    const prev = prevRef.current;
    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts.length && LANGS.includes(parts[0])) parts.shift();
      return "/" + parts.join("/");
    };
    const sameContent = stripLang(prev) === stripLang(pathname);
    prevRef.current = pathname;
    if (!sameContent) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname]);

  return null;
}
